import List from './list/LabResearchIcdCodeListInitialState'

const { Record } = require('immutable')

export default Record({
    list: List()
})